<ng-content></ng-content>
<app-image-uploader
  [uploadUrl]="uploadUrl$ | async"
  [formControl]="imageUrl"
  [customUploader]="customizeFileUploader"
></app-image-uploader>

<button
  mat-button
  *ngIf="imageUrl.value !== ''"
  color="warn"
  (click)="deleteImage()"
>
  {{ 'COMMON.ACTION_LABELS.DELETE' | translate }}
</button>
